import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import type { LabReqField } from '@care-portals/api-interfaces';

@Component({
  selector: 'my-health-input-element',
  templateUrl: './input-element.component.html',
  styleUrls: ['./input-element.component.less']
})
export class InputElementComponent implements OnInit, OnChanges {
  @Input() inputForm: FormGroup;
  @Input() field: LabReqField;

  constructor(private ref: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.ref.detectChanges();
  }
}
